

































/**
 * 常规展示专辑的 item
 */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Artist } from '@/interfaces';
import { ABAction } from '@/stores/audioBar';

@Component
export default class AlbumCard extends Vue {
  @Prop({
    type: Number,
    required: true,
  }) public id!: number;

  @Prop({
    type: String,
    required: true,
  }) public src!: string;

  @Prop({
    type: String,
    required: true,
  }) public playLink!: string;

  @Prop({
    type: String,
    required: true,
  }) public name!: string;

  @Prop({
    type: Array,
    required: true,
  }) public artists!: Artist[];

  /**
   * 点击专辑歌单
   */
  public handleClickPlay() {
    // 拉取专辑并播放第一首
    this.$store.dispatch(ABAction('startPlayNewList'), {
      id: this.id,
      type: 'ALBUM',
    });
  }
}
